import { useQuery } from '@tanstack/react-query'
import { Coins } from 'lucide-react'
import { getMyCommissions } from '../../services/api.js'

const nf = new Intl.NumberFormat('fr-FR')
const money = (v) => `${nf.format(Math.round(Number(v) || 0))} €`
const dateFmt = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' })
const formatDate = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : dateFmt.format(d)
}

export default function MyCommissions() {
  const { data, isLoading } = useQuery({ queryKey: ['myCommissions'], queryFn: getMyCommissions })

  if (isLoading) return null
  // Rien à afficher si aucune vente commissionnée.
  if (!data || data.count === 0) return null

  const items = data.items.slice(0, 5)

  return (
    <section className="mb-6 rounded-2xl border border-white/10 bg-black/20 p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-white/80">
          <Coins className="h-4 w-4 text-[#5b5cf4]" />
          Mes commissions
        </h2>
        <span className="text-xs text-white/40">taux courant : {data.currentRate} %</span>
      </div>

      <div className="mb-3 flex items-baseline gap-3">
        <span className="text-2xl font-bold text-[#5b5cf4]">{money(data.total)}</span>
        <span className="text-xs text-white/45">sur {data.count} vente{data.count > 1 ? 's' : ''} gagnée{data.count > 1 ? 's' : ''}</span>
      </div>

      <ul className="space-y-1.5">
        {items.map((it) => (
          <li key={it.projectId} className="flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2">
            <div className="min-w-0">
              <p className="truncate text-sm text-white">{it.title || it.projectId}</p>
              <p className="text-[11px] text-white/40">
                {it.customerName ? `${it.customerName} · ` : ''}{formatDate(it.commissionedAt)} · {it.commissionRate} %
              </p>
            </div>
            <span className="shrink-0 text-sm font-semibold text-[#5b5cf4]">{money(it.commissionAmount)}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
